import * as THREE from 'three';
import { BufferGeometry, LineBasicMaterial } from 'three';
class LineLoop extends THREE.LineLoop {
    props;
    constructor(data) {
        const material = new LineBasicMaterial({
            color: 0xff0000,
        });
        const geometry = new BufferGeometry();
        super(geometry, material);
        this.props = data;
        this.name = this.uuid;
        const points = [];
        points.push(new THREE.Vector3(500, 500, 0));
        points.push(new THREE.Vector3(500, -500, 0));
        points.push(new THREE.Vector3(-500, -500, 0));
        points.push(new THREE.Vector3(-500, 500, 0));
        // 绑定顶点到空几何体
        geometry.setFromPoints(points);
        this.geometry = geometry;
        this.material = material;
    }
    dispose() {
        const { onDestory } = this.props;
        this.parent?.remove(this);
        this.material.dispose();
        this.geometry.dispose();
        if (onDestory && typeof onDestory === 'function') {
            onDestory(this);
        }
    }
}
export default LineLoop;
